import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Printer } from 'lucide-react';
import { useCart } from '../../hooks/useCart';
interface StorefrontHeaderProps {
  storeName: string;
  storeSlug: string;
  organizationName: string;
}
export function StorefrontHeader({
  storeName,
  storeSlug,
  organizationName
}: StorefrontHeaderProps) {
  const {
    itemCount
  } = useCart();
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-40" data-id="element-234">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        <div className="flex items-center justify-between h-16" data-id="element-236">
          <Link to={`/store/${storeSlug}`} className="flex items-center space-x-3" data-id="element-237">
            <div className="h-10 w-10 bg-red-600 rounded-lg flex items-center justify-center" data-id="element-238">
              <Printer className="h-6 w-6 text-white" data-id="element-239" />
            </div>
            <div data-id="element-240">
              <h1 className="text-lg font-bold text-gray-900" data-id="element-241">{storeName}</h1>
              <p className="text-xs text-gray-500" data-id="element-242">{organizationName}</p>
            </div>
          </Link>

          <Link to={`/store/${storeSlug}/cart`} className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-243">
            <ShoppingCart className="h-6 w-6 text-gray-700" data-id="element-244" />
            {itemCount > 0 && <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center" data-id="element-245">
                {itemCount}
              </span>}
          </Link>
        </div>
      </div>
    </header>;
}